<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      line-form
      show-save-button
      unit="员工档案"
      edit-title
      id-key="EmpId"
      :data="data"
      @create-opened="onCreateOpened"
      @opened="onOpened"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="员工姓名" prop="EmpName" label-width="120px">
              <el-input
                v-model="data.EmpName"
                placeholder="请输入员工姓名"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证" prop="Idnumber" label-width="120px">
              <el-input
                v-model="data.Idnumber"
                placeholder="请输入身份证"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="性别"
              prop="Sex"
              label-width="120px"
              class="notBottom"
            >
              <el-radio v-model="data.Sex" :label="0">男</el-radio>
              <el-radio v-model="data.Sex" :label="1">女</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="婚否"
              prop="MaritalStatus"
              label-width="120px"
              class="notBottom"
            >
              <el-radio v-model="data.MaritalStatus" :label="0">未婚</el-radio>
              <el-radio v-model="data.MaritalStatus" :label="1">已婚</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="Birthday" label-width="120px">
              <el-date-picker
                v-model="data.Birthday"
                value-format="yyyy-MM-dd"
                type="date"
                @change="getAge"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="员工编码" prop="EmpNo" label-width="120px">
              <el-input
                v-model="data.EmpNo"
                placeholder="请输入员工编码"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄" label-width="120px" class="notBottom">
              <span>{{ data.Age }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="iShow('NativePlace')">
            <el-form-item label="户口所在地" label-width="120px">
              <el-input
                v-model="data.NativePlace"
                placeholder="请输入户口所在地"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="iShow('Address')">
            <el-form-item label="通讯地址" label-width="120px">
              <el-input
                v-model="data.Address"
                placeholder="请输入通讯地址"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone" label-width="120px">
              <el-input
                v-model="data.Phone"
                placeholder="请输入联系电话"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系邮箱" label-width="120px" prop="Email">
              <el-input
                v-model="data.Email"
                placeholder="请输入联系邮箱"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职日期" prop="EntryDate" label-width="120px">
              <el-date-picker
                v-model="data.EntryDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职岗位" prop="JobName" label-width="120px">
              <el-input
                v-model="data.JobName"
                placeholder="请输入入职岗位"
                @click.native="openJobDialog"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职职级" prop="RankName" label-width="120px">
              <el-input
                v-model="data.RankName"
                placeholder="请输入入职职级"
                @click.native="openRankDialog"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="入职状态"
              prop="EntryStatus"
              label-width="120px"
              class="notBottom"
            >
              <el-radio v-model="data.EntryStatus" :label="0"
                >试用员工</el-radio
              >
              <el-radio v-model="data.EntryStatus" :label="1"
                >正式员工</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入职部门" prop="DpName" label-width="120px">
              <tree-select
                ref="dpTreeSelect"
                :props="DpProps"
                :options="DpTreeData"
                :value="data.DpId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onDpTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入职职位" label-width="120px" prop="TypeName">
              <el-input
                v-model="data.TypeName"
                placeholder="请输入入职职位"
                @click.native="openEmpDialog"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="iShow('School')">
            <el-form-item label="毕业学校" label-width="120px">
              <el-input
                v-model="data.School"
                placeholder="请输入毕业学校"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('Education')">
            <el-form-item label="学历" label-width="120px">
              <el-input
                v-model="data.Education"
                placeholder="请输入学历"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('Major')">
            <el-form-item label="专业" label-width="120px">
              <el-input
                v-model="data.Major"
                placeholder="请输入专业"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="账号状态"
              prop="AccountStatus"
              label-width="120px"
              class="notBottom"
            >
              <el-radio v-model="data.AccountStatus" :label="0"
                >停用</el-radio
              >
              <el-radio v-model="data.AccountStatus" :label="1"
                >启用</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="iShow('Contact')">
            <el-form-item label="紧急联系人" label-width="120px">
              <el-input
                v-model="data.Contact"
                placeholder="请输入紧急联系人"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('EmergencyPhone')">
            <el-form-item
              label="紧急联系人电话"
              label-width="120px"
              prop="EmergencyPhone"
            >
              <el-input
                v-model="data.EmergencyPhone"
                placeholder="请输入紧急联系人电话"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="iShow('ContactRelationship')">
            <el-form-item label="紧急联系人关系" label-width="120px">
              <el-input
                v-model="data.ContactRelationship"
                placeholder="请输入紧急联系人关系"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="iShow('FileUrl')">
          <el-col :span="24">
            <el-form-item label="附件" label-width="120px" class="notBottom">
              <!-- <el-input v-model="data.attachment" placeholder="请输入部门编码" /> -->
              <upload-file-list
                :file-list="FileUrl"
                @success="onFileSuccess"
                @delete="onFileDelete"
              ></upload-file-list>
              <!-- <upload-file :tip="tip"></upload-file> -->
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>

    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <job-dialog ref="jobDialog" in-dialog selectable @select="setJob" />
    <rank-dialog ref="rankDialog" in-dialog selectable @select="setRank" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import uploadFileList from "@/components/common/files/oneUploadFileList";
// import empDialog from "@/components/personnel/result/record/listDialog";
import empDialog from "@/components/basedata/personnel/employee/listDialog";
import jobDialog from "@/components/basedata/personnel/job/listDialog";
import rankDialog from "@/components/basedata/personnel/rank/listDialog";
import treeSelect from "@/components/common/treeSelect";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    uploadFileList,
    empDialog,
    jobDialog,
    rankDialog,
    treeSelect,
  },
  data() {
    return {
      data: {
        EmpId: 0,
        EmpName: "",
        EmpNo:null,
        Idnumber: "",
        Age: "",
        Sex: 1,
        // 部门
        DpId: null,
        DpName: "",
        // 岗位
        JobId: null,
        JobName: "",
        // 职位
        EmpTypeId: null,
        TypeName: "",
        // 职级
        RankId: "",
        RankName: "",
        MaritalStatus: 1,
        Birthday: "",
        NativePlace: "",
        Address: "",
        Phone: null,
        Email: "",
        EntryDate: "",
        EntryStatus: 1,
        AccountStatus:1,
        School: "",
        Education: "",
        Major: "",
        Contact: "",
        EmergencyPhone: "",
        ContactRelationship: "",
        FileUrl: "",
        FileName: "",
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ent/emp").default,
      jobApi: require("@/api/ent/job").default,
      empTypeApi: require("@/api/ent/emptype").default,
      rankApi: require("@/api/ent/rank").default,
      dpApi: require("@/api/ent/dp").default,
      code_api: require("@/api/sy/serialCode").default,
      FileUrl: [],
      jobList: [],
      empTypeList: [],
      rankList: [],
      showList: [],
      DpTreeData: [],
      DpProps: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      rules: {
        EmpName: [{ required: true, message: "员工姓名不能为空" }],
        // Idnumber: [
        //   { required: true, message: "身份证不能为空" },
        //   { validator: this.$commonJs.validateRules.idCard },
        // ],
        Birthday: [{ required: true, message: "出生日期不能为空" }],
        Phone: [
          { required: true, message: "联系电话不能为空" },
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        EmergencyPhone: [
          { validator: this.$commonJs.validateRules.validPhone2 },
        ],
        Sex: [{ required: true, message: "性别不能为空" }],
        MaritalStatus: [{ required: true, message: "婚否不能为空" }],
        EntryDate: [{ required: true, message: "入职日期不能为空" }],
        TypeName: [{ required: true, message: "入职职位不能为空" }],
        JobName: [{ required: true, message: "入职岗位不能为空" }],
        RankName: [{ required: true, message: "入职职级不能为空" }],
        EntryStatus: [{ required: true, message: "入职状态不能为空" }],
        DpName: [{ required: true, message: "入职部门不能为空" }],
        Email: [
          { required: true, message: "邮箱不能为空" },
          { validator: this.$commonJs.validateRules.validEmail },
        ],
      },
      tip: "请先修改好文件名再上传，大小不超过10Mb",
    };
  },

  methods: {
    onCreateOpened() {
      this.data.EmpNo = null
      this.serialCode()
    },
    
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
      // 部门
      this.dpApi.list({}).then((res) => {
        this.DpTreeData = this.arrayToTree(res.Data, "DpId");
        // this.$refs.dpTreeSelect.setData(this.data.DpId);
      })
    },
    onEditOpened(data) {
      this.api.info(data.EmpId).then((res) => {
        if (res.Code === 0) {
          this.data = res.Data;
          // 部门
          this.dpApi
            .list({})
            .then((res) => {
              this.DpTreeData = this.arrayToTree(res.Data, "DpId");
              this.$refs.dpTreeSelect.setData(this.data.DpId);
            })
            .then(() => {
              this.empTypeApi.list({ DpId: this.data.DpId }).then((v) => {
                this.employeeList = v.Data;
              });
            });
          if (data.FileUrl && data.FileUrl != "") {
            let FileUrl = data.FileUrl.split("/");
            this.FileUrl = [
              {
                FileName: FileUrl[FileUrl.length-1],
                FileUrl: data.FileUrl,
              },
            ];
          }
        }
      });
    },
    serialCode() {
      this.code_api.previewNo("人员").then((res) => {
        if (res.Code == 0) {
          this.data.EmpNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取人员编号编号失败");
        }
      });
    },
    // onOpened() {
    //   // this.$refs.typeSelect.init();
    // },
    onBeforeSave() {},

    //判断显示
    iShow(data) {
      //console.log(this.showList);
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    getAge(data) {
      console.log(data);
      if (data == "") return (this.data.Age = "");
      // 将出生日期的字符串通过"-"分割成数组
      const strBirthdayArr = data?.split("-");
      // 拿到出生日期的年
      const birthYear = strBirthdayArr[0];
      // 拿到出生日期的月
      const birthMonth = strBirthdayArr[1];
      // 拿到出生日期的日
      const birthDay = strBirthdayArr[2];
      // 创建一个时间对象
      const d = new Date();
      // 拿到当前时间的年
      const nowYear = d.getFullYear();
      // 拿到当前时间的月
      const nowMonth = d.getMonth() + 1;
      // 拿到当前时间的日
      const nowDay = d.getDate();
      // 如果出生日期的年等于当前时间的年
      if (nowYear === birthYear) return 0; // 返回周岁年龄 0,并终止函数执行
      // 如果如果出生日期的年不等于于当前时间的年,则拿到年之差
      const ageDiff = nowYear - birthYear; // 年之差
      // 如果年之差是个负数,则表示用户输入的出生日期错误,晚于今天,返回 -1,并终止函数执行
      if (ageDiff < 0) return -1; // 返回错误 -1,并终止函数执行
      // 如果年之差是个正整数,但出生日期的月与当前时间的月不相等
      if (nowMonth !== birthMonth) {
        // 拿到出生日期的日与当前时间的月之差
        const monthDiff = nowMonth - birthMonth; // 月之差
        // 如果月之差是个负数,则年之差 - 1后得到周岁年龄,否则直接得到周岁年龄
        return (this.data.Age = monthDiff < 0 ? ageDiff - 1 : ageDiff); // 返回周岁年龄,并终止函数执行
      }
      // 如果出生日期的月与当前时间的月相等,则拿到出生日期的日与当前时间的日之差
      const dayDiff = nowDay - birthDay;
      // 如果日之差是个负数,则年之差 - 1得到周岁年龄,否则直接得到周岁年龄

      return (this.data.Age = dayDiff < 0 ? ageDiff - 1 : ageDiff); // 返回周岁年龄,并终止函数执行
    },
    openJobDialog() {
      this.$refs.jobDialog.open();
    },
    openRankDialog() {
      this.$refs.rankDialog.open();
    },
    openDpDialog() {
      this.$refs.dpDialog.open();
    },
    openEmpDialog() {
      this.$refs.empDialog.open();
    },
    setEmp(emp) {
      console.log(emp);
      this.data.EmpTypeId = emp.EmpTypeId;
      this.data.TypeName = emp.TypeName;
    },
    setRank(rank) {
      console.log(rank);
      this.data.RankId = rank.RankId;
      this.data.RankName = rank.RankName;
    },
    setJob(job) {
      console.log(job);
      this.data.JobId = job.JobId;
      this.data.JobName = job.JobName;
    },
    setDp(dp) {
      console.log(dp);
      this.data.DpId = dp.DpId;
      this.data.DpName = dp.DpName;
    },
    onDpTreeSelect(t) {
      this.data.DpName = !t ? "" : t.DpName;
      this.data.DpId = !t ? null : t.DpId;
    },
    arrayToTree(items, styleId) {
      const result = []; // 存放结果集
      const itemMap = {}; //
      for (const item of items) {
        const id = item[styleId];
        const pid = item.Pid;

        if (!itemMap[id]) {
          itemMap[id] = {
            children: [],
          };
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]["children"],
        };

        const treeItem = itemMap[id];

        if (pid === 0) {
          result.push(treeItem);
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: [],
            };
          }
          itemMap[pid].children.push(treeItem);
        }
      }
      return result;
    },
    onFileSuccess(res) {
      var data = res.Data;
      this.FileUrl = [
        {
          Extension: "",
          FileName: data.FileName,
          FilePath: data.FilePath,
          Msg: data.Msg,
          FileUrl: data.VirtualPath,
        },
      ];
      this.data.FileUrl = data.VirtualPath;
      this.data.FileName = data.FileName;
    },
    onFileDelete(index) {
      this.data.FileUrl = "";
      this.data.FileName = "";
      this.FileUrl = [];
    },
    onClosed(){
      this.FileUrl = []
      this.jobList = []
      this.empTypeList = []
      this.rankList = []
      this.showList = []
      this.DpTreeData = []
  
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>
